// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1vwa7","tab":"ProcedureTabs_tab__167oP"};